export const cleanPhone = (value: string) =>
  value.replaceAll("-", "").replaceAll(/\D/g, "").substring(0, 10);

/**
 * Strip ALL whitespace (spaces, tabs, newlines) from a value while preserving
 * everything else. Used on phone number inputs so users can still type
 * formatting characters like `(404) 555-0123` but spaces never make it into
 * the field value.
 */
export const stripWhitespace = (value: string) => value.replaceAll(/\s+/g, "");
